import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { TranslocoDirective } from "@jsverse/transloco";
import { AsinSelectionComponent } from "@m19-board/shared/asin-selection/asin-selection.component";

export interface DspCreateAudienceProductsModel {
  asins: string[];
}

@Component({
  selector: "app-dsp-create-audience-products-step",
  host: { class: "block h-full min-h-0" },
  imports: [TranslocoDirective, AsinSelectionComponent],
  template: `
    <div class="flex h-full min-h-0 flex-col gap-6 overflow-hidden py-8" *transloco="let t">
      <div class="flex shrink-0 flex-col gap-1">
        <h4>{{ t("dsp-create-audiences-page.select_your_products") }}</h4>
        <p class="type-body text-muted-foreground m-0">{{ t("dsp-create-audiences-page.choose_products_to_add") }}</p>
      </div>
      <div class="min-h-0 flex-1">
        <app-asin-selection
          class="block h-full max-w-full"
          [selectedAsins]="products().asins().value()"
          (selectedAsinsChange)="selectAsins($event)"
          [bulkButtonLabel]="t('dsp-create-audiences-page.add_external_products')"
          [allowOtherCatalog]="true"
        />
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspCreateAudienceProductsStepComponent {
  readonly products = input.required<FieldTree<DspCreateAudienceProductsModel>>();

  selectAsins(asins: string[]) {
    this.products().asins().markAsDirty();
    this.products().asins().value.set(asins);
  }
}
